import { Icon } from './Icon';

/**
 * Warm Paper brand mark — a diagonal Cozy/Graphite split with the layered glyph,
 * used as the in-app logo everywhere. Intentionally fixed two-tone (it shows both
 * house themes at once); the orange `/favicon.svg` stays as the browser-tab identity.
 */
export function LogoMark({ size = 30, radius, shadow = false }: { size?: number; radius?: number; shadow?: boolean }) {
  const r = radius ?? Math.round(size * 0.28);
  return (
    <div
      style={{
        width: size,
        height: size,
        flex: 'none',
        borderRadius: r,
        position: 'relative',
        overflow: 'hidden',
        display: 'grid',
        placeItems: 'center',
        // diagonal split: Cozy olive (top-left) → Graphite charcoal (bottom-right)
        background: 'linear-gradient(135deg, #8a9a57 0%, #6d7c40 50%, #2c2c2e 50%, #161617 100%)',
        boxShadow: shadow ? '0 10px 24px -10px rgba(20,16,10,.45)' : undefined,
      }}
    >
      <Icon name="layers2" size={Math.round(size * 0.52)} style={{ color: '#fbfaf7' }} />
    </div>
  );
}
